import { Component, OnInit } from '@angular/core';
import {AuthService} from '@app/core/auth/auth.service';

@Component({
  selector: 'app-optional-header-layout',
  templateUrl: './optional-header-layout.component.html',
  styleUrls: ['./optional-header-layout.component.scss']
})
export class OptionalHeaderLayoutComponent implements OnInit {

  constructor(public auth: AuthService) { }

  ngOnInit(): void {
  }

}
